import React from 'react'

const Subscription = () => {
  return (
    <h2>Subscription</h2>
  )
}

export default Subscription